import Header from "../components/Header";
import StatsCards from "../components/StatsCards";
import ChartSection from "../components/ChartSection";
import Movements from "../components/Movements";
import Cashinout from "../components/Investment_Deinvestment";
import Contact from "../components/Name&Contract"

export default function Dashboard() {
  return (
    <div className="app-container">
      <Header />
      <Contact />
      <Cashinout />
      <StatsCards />
      <ChartSection />
      <Movements />
    </div>
  );
}